<div class="container">
    <div class="head-content">
        <div class="head">
            <div class="head__title">{{'label.Title' | translate}}</div>
            <div class="head__application-date">{{'label.ApplicationDate' | translate}}</div>
            <div class="head__status">{{'label.Status' | translate}}</div>
        </div>
    </div>
    <div class="body-content">
        <div  *ngFor="let application of cvBoxApplications$ | async"  class="body">
            <a *ngIf="application.customerStatusId == customerStatus.Active"
                [routerLink]="['/customer', application.customerId]" 
                class="body__customer body__customer--link">
                {{application.customerName}}
            </a>
            <div *ngIf="application.customerStatusId != customerStatus.Active"
                class="body__customer body__customer--without-link">
                {{application.customerName}}
            </div>

            <div class="body__application-date">{{application.date | date:'M/d/yy'}}</div>

            <div [ngClass]="{'body__status--approve': application.statusId == cvBoxApplicationStatus.Approved,
                             'body__status--pending': application.statusId == cvBoxApplicationStatus.Pending,
                             'body__status--rejected': application.statusId == cvBoxApplicationStatus.Rejected}"
                 class="body__status"> 
                 {{applicationStatusNameMap[application.statusId] | translate}}
            </div>
        </div>
    </div>

    <div *ngIf="(cvBoxApplications$ | async)?.length > 0" class="paging">
        <ng-container *ngIf="{
            pageCount: pageCount$ | async,
            navItems: navItems$ | async,
            currentPage: currentPage$ | async
        } as data">
            <app-paging [currentPage]="data.currentPage" [pageCount]="data.pageCount" [pagingNavItems]="data.navItems" (onPageNav)="onPagignNavigation($event)"></app-paging>
        </ng-container>
    </div>
</div>